// moment().add(Object) の引数 Object の型に則って定義する
// 配送到着日指定範囲
const DeliveryPreferredDuration = {
  days: 7
};

export default DeliveryPreferredDuration;



// WEBPACK FOOTER //
// ./src/constants/delivery-preferred-duration.js